import React from "react";
import "./common.scss";
import { ReactComponent as CheckedBox } from "../../Assets/Icons/checkedBox.svg";
import { ReactComponent as UncheckedBox } from "../../Assets/Icons/uncheckedBox.svg";

const Checkbox = ({
  divClassName,
  text,
  checked,
  onChecked,
  textClass,
  UncheckedIcon,
  checkClassName,
}) => {
  return (
    <>
      <div className={divClassName}>
        {checked == true ? (
          <div className="mt-[4px]">
            <CheckedBox onClick={onChecked} className={`checkbox ${checkClassName}`} />
          </div>
        ) : UncheckedIcon ? (
          <div className="mt-[4px]">
            <UncheckedIcon onClick={onChecked} className={`checkbox ${checkClassName}`} />
          </div>
        ) : (
          <div className="mt-[4px]">
            <UncheckedBox onClick={onChecked} className={`checkbox ${checkClassName}`} />
          </div>
        )}
        <label className={textClass} onClick={onChecked}>{text}</label>
      </div>
    </>
  );
};

export default Checkbox;
